// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1MCEf","col":"styles_col__2rStG"};